<template>
  <div>
    <!-- Footer Section Start Here -->
    <footer>
      <div class="footer-top padding-tb">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="footer-item first-set">
                <div class="footer-inner">
                  <div class="footer-content">
                    <div class="title">
                      <h6>Covid-19-Flu</h6>
                    </div>
                    <div class="content">
                      <p>
                        Dillon Parchment
                      </p>
                      <h6>Software Engineer/Application Developer</h6>
                      <p>Kingston, Jamaica</p>
                      <ul class="lab-ul">
                        <li>
                          <p>
                            <span>Email:</span
                            ><a href="#">parchie876ix@gmail.com</a>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="footer-item">
                <div class="footer-inner">
                  <div class="footer-content">
                    <div class="title">
                      <h6>Social Contact</h6>
                    </div>
                    <div class="content">
                      <ul class="lab-ul">
                        <li>
                          <a href="https://twitter.com/parchie876ix"
                            ><i class="mdi mdi-twitter"></i>Twitter</a
                          >
                        </li>
                        <li>
                          <a href="https://www.instagram.com/parchie876/"
                            ><i class="mdi mdi-instagram"></i>Instagram</a
                          >
                        </li>
                        <li>
                          <a href="https://jm.linkedin.com/in/dillonparchment"
                            ><i class="mdi mdi-linkedin"></i>Linkedin</a
                          >
                        </li>
                        <li>
                          <a href="https://github.com/Parchie876"
                            ><i class="mdi mdi-github"></i>GitHub</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="container">
          <div class="section-wrapper">
            <p>
              © 2020 All Rights Reserved. Designed by
              <a href="https://github.com/Parchie876">Dillon Parchment</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer Section Ending Here -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  components: {},
};
</script>
